import {
  DateRangePickerButton,
  FilterOptionButton,
} from '@/components/common/FilterButtons';
import { format } from 'date-fns';
import { useState } from 'react';

export type StatisticsDoctorCategory = 'doctors' | 'clinics';

export interface StatisticsDoctorAppliedFilters {
  category: StatisticsDoctorCategory;
  dateFrom: string;
  dateTo: string;
}

const CATEGORY_LABELS: Record<StatisticsDoctorCategory, string> = {
  doctors: 'Doctors',
  clinics: 'Clinics',
};

interface StatisticsDoctorFiltersProps {
  onApply: (filters: StatisticsDoctorAppliedFilters) => void;
}

export function StatisticsDoctorFilters({
  onApply,
}: StatisticsDoctorFiltersProps) {
  const [activeCategory, setActiveCategory] =
    useState<StatisticsDoctorCategory>('doctors');
  const [dateFrom, setDateFrom] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [dateTo, setDateTo] = useState('');
  const [isDateActive, setIsDateActive] = useState(false);

  const applyFilters = (
    overrides?: Partial<{
      category: StatisticsDoctorCategory;
      dateFrom: string;
      dateTo: string;
      isDateActive: boolean;
    }>,
  ) => {
    const cat = overrides?.category ?? activeCategory;
    const df = overrides?.dateFrom ?? dateFrom;
    const dt = overrides?.dateTo ?? dateTo;
    const da = overrides?.isDateActive ?? isDateActive;
    onApply({
      category: cat,
      dateFrom: da ? df : '',
      dateTo: da ? dt : '',
    });
  };

  const handleCategoryChange = (category: StatisticsDoctorCategory) => {
    setActiveCategory(category);
    applyFilters({ category });
  };

  const handleDateRangeChange = (from: string, to: string) => {
    setDateFrom(from);
    setDateTo(to);
    setIsDateActive(true);
    applyFilters({ dateFrom: from, dateTo: to, isDateActive: true });
  };

  return (
    <div className="flex flex-wrap gap-x-8 gap-y-4">
      <div className="flex flex-wrap gap-2">
        {(Object.keys(CATEGORY_LABELS) as Array<StatisticsDoctorCategory>).map(
          (category) => (
            <FilterOptionButton
              key={category}
              label={CATEGORY_LABELS[category]}
              isActive={activeCategory === category}
              onClick={() => handleCategoryChange(category)}
            />
          ),
        )}
      </div>

      <div className="flex flex-wrap items-end gap-3">
        <DateRangePickerButton
          dateFrom={dateFrom}
          dateTo={dateTo}
          onDateRangeChange={handleDateRangeChange}
          isActive={isDateActive}
        />
      </div>
    </div>
  );
}
